import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import Logo from 'components/interactiveComponents/Logo';
import BetaLable from 'components/interactiveComponents/BetaLable';
import icon from 'media/images/svgSprite.svg';

import {
  BackDrop,
  MenuWrap,
  CloseButton,
  IconClose,
  MenuLogoWrap,
  ToolList,
  Tool,
  ElemLink,
  NavIconWrap,
  ToolsIcon,
  TitleWrap,
  ToolsTitle,
} from 'components/SharedLayout/MainMenu/MainMenu.styled';

const mainMenuRoot = document.getElementById('burger-menu');

const toolsMeta = [
  {
    title: 'AI PHOTO SHOOTING',
    link: 'ai-photoshooting/gallery',
    toolIcon: 'ai-photoshooting',
  },
  {
    title: 'AI AVATARS',
    link: 'ai-avatars/gallery',
    toolIcon: 'ai-avatars',
  },
  {
    title: 'IMAGE UPSCALING',
    link: 'image-upscaling/gallery',
    toolIcon: 'upscale',
  },
  {
    title: 'BACKGROUND REMOVE',
    link: 'bg-remove/gallery',
    toolIcon: 'removebg',
  },
  {
    title: 'AI FASHION STORE',
    link: 'ai-fashion-store/gallery',
    toolIcon: 'fashion-store',
  },
];

const MainMenu = ({ onCloseMenu, isClosing, isVisible }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handlePressESC = e => {
      if (e.code === 'Escape') {
        onCloseMenu();
      }
    };

    window.addEventListener('keydown', handlePressESC);

    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('keydown', handlePressESC);
    };
  }, [onCloseMenu]);

  function handleClickOnBackDrop(e) {
    if (e.target.nodeName === 'DIV' && e.currentTarget.nodeName === 'DIV') {
      onCloseMenu();
    }
  }

  function handleClickLink(e) {
    e.stopPropagation();
    onCloseMenu();
  }

  return createPortal(
    <BackDrop
      onClick={handleClickOnBackDrop}
      $opacity={isVisible}
      $isOpenClose={isClosing}
    >
      <MenuWrap $isOpenClose={isClosing} $opacity={isVisible}>
        <CloseButton type="button" onClick={handleClickLink}>
          <IconClose>
            <use href={`${icon}#icon-arrow-left-2`}></use>
          </IconClose>
        </CloseButton>

        <MenuLogoWrap onClick={handleClickLink}>
          <Logo iconName={'logo'} />
          <BetaLable
            topLablePos={'4px'}
            rightLablePos={'-42px'}
            topMessagePos={'58px'}
            bottomMessagePos={'auto'}
            leftMessagePos={'-40px'}
            translateXValue={'0'}
            lableLocation={'menu'}
          />
        </MenuLogoWrap>

        <ToolList>
          {toolsMeta.map(tool => {
            return (
              <Tool key={tool.toolIcon} onClick={handleClickLink}>
                <ElemLink to={tool.link}>
                  <NavIconWrap>
                    <ToolsIcon>
                      <use href={`${icon}#icon-${tool.toolIcon}`}></use>
                    </ToolsIcon>
                  </NavIconWrap>
                  <TitleWrap>
                    <ToolsTitle>{tool.title}</ToolsTitle>
                  </TitleWrap>
                </ElemLink>
              </Tool>
            );
          })}
        </ToolList>
      </MenuWrap>
    </BackDrop>,
    mainMenuRoot
  );
};

export default MainMenu;
